import { render, staticRenderFns } from "./Vas5Question.vue?vue&type=template&id=29ff283a&scoped=true"
import script from "./Vas5Question.vue?vue&type=script&lang=js"
export * from "./Vas5Question.vue?vue&type=script&lang=js"
import style0 from "./Vas5Question.vue?vue&type=style&index=0&id=29ff283a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ff283a",
  null
  
)

export default component.exports